import React from 'react';
import './PauseScreen.css';

const PauseScreen = ({ onAction }) => {
  return (
    <div className="pause-screen">
      <div className="pause-background">
        <div className="pause-banner">
          <h1>Connect 4</h1>
        </div>
        
        <div className="pause-content">
          <h2 className="pause-text">CONNECT 4 IS PAUSED</h2>
          
          <div className="pause-buttons">
            <button 
              className="pause-btn resume-btn"
              onClick={() => onAction('resume')}
            >
              Resume Game
            </button>
            
            <button 
              className="pause-btn restart-btn"
              onClick={() => onAction('restart')}
            >
              Restart Game
            </button>
            
            <button 
              className="pause-btn menu-btn"
              onClick={() => onAction('menu')}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PauseScreen;
